import GeneratedOfferStore from "./generated/GeneratedOfferStore"

class OfferStore extends GeneratedOfferStore {

}

export const offerStore = new OfferStore()
